import React from 'react'

import DownIcon from '../../../assets/icons/chevron-down.svg?react'

type Props = { children: React.ReactNode | string, label: React.ReactNode | string, defaultOpen?: boolean}
const Expandable: React.FC<Props> = ({ label, children, defaultOpen }) => {
  const [isOpen, setIsOpen] = React.useState(defaultOpen)
  return (
    <div className='py-1 cursor-pointer'>
      <div onClick={() => setIsOpen(!isOpen)} className='w-full'>
        <div className='w-full text-start'>
          <strong className='text-xs sm:text-sm flex justify-between items-center leading-none'>
            {label} {isOpen ?  <DownIcon className='rotate-180' /> : <DownIcon />}
          </strong>
        </div>
      </div>
      {isOpen && (
        <div className='py-4 font-light'>
          {children}
        </div>
      )}
    </div>
  )
}

export default Expandable
